import Vue from 'vue'
import LLoading from './../components/loading/loading'

const toggleLoading = (el,binding)=>{
  if(binding.value){
    console.log(el)
    Vue.nextTick(()=>{
      el.addClass('lloading-parent-relative')
      el.appendChild(el.mask)
      el.domVisible = true
    })
  }else {
    el.domVisible = false;
    el.style.position = ''
  }
}

Vue.directive('LLoading',{
  bind:function (el,binding) {
    if (Vue.prototype.$isServer) return;
    const Mask = Vue.extend(LLoading)
  
    const MaskInstance = new Mask({
      el:document.createElement('div'),
      data(){
        return {}
      }
    })
    console.log(el)
    el.instance = MaskInstance
    el.mask = MaskInstance.$el
    binding.value && toggleLoading(el,binding)
  },
  update: function (el, binding) {
    if(binding.value !== binding.oldValue) {
      toggleLoading(el,binding)
    }
  },
  //指令与元素解绑时调用
  unbind: function (el) {
    el.instance && el.instance.$destroy()
  }
})
